﻿/* FAQ filter: search + topic buttons */
(function () {
  'use strict';
  function init(root) {
    var q = root.querySelector('[data-ic-faq-q]');
    var btns = [].slice.call(root.querySelectorAll('[data-ic-faq-cat]'));
    var items = [].slice.call(root.querySelectorAll('[data-ic-faq-item]'));
    var groups = [].slice.call(root.querySelectorAll('[data-ic-faq-group]'));
    var empty = root.querySelector('[data-ic-faq-empty]');
    var count = root.querySelector('[data-ic-faq-count]');
    var cat = '';
    function run() {
      var term = (q.value || '').trim().toLowerCase();
      var shown = 0;
      items.forEach(function (it) {
        var okCat = !cat || it.dataset.cat === cat;
        var okTerm = !term || (it.dataset.text + ' ' + it.textContent).toLowerCase().indexOf(term) !== -1;
        var ok = okCat && okTerm;
        it.hidden = !ok; if (ok) { shown++; if (term) it.open = true; }
      });
      groups.forEach(function (g) { g.hidden = !g.querySelector('[data-ic-faq-item]:not([hidden])'); });
      if (empty) empty.hidden = shown > 0;
      if (count) count.textContent = shown + ' of ' + items.length + ' questions shown';
    }
    q.addEventListener('input', run);
    btns.forEach(function (b) { b.addEventListener('click', function () { cat = b.dataset.icFaqCat; btns.forEach(function (x) { x.classList.toggle('is-active', x === b); }); run(); }); });
    run();
  }
  function boot() { document.querySelectorAll('.ic-faqpage').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
